<div
  class="w-full max-w-6xl mx-auto flex flex-col gap-4 border border-gray-300 rounded-lg bg-white"
>
  <lib-feature-header title="New Commission Invoice" (closeClick)="goBack()" />

  @if (store.error()) {
  <div class="px-4">
    <lib-error-alert [error]="store.error()" />
  </div>
  }

  <div class="flex flex-col gap-4 px-4 pb-4">
    <div class="flex flex-wrap gap-2 border-b border-gray-200 pb-3">
      @for (step of CREATE_STEPS; track step.value; let i = $index) {
      <button
        type="button"
        class="inline-flex items-center rounded-md border px-3 py-2 text-sm font-medium"
        [class.border-orange-500]="store.step() === step.value"
        [class.bg-orange-50]="store.step() === step.value"
        [class.text-orange-700]="store.step() === step.value"
        [class.border-gray-300]="store.step() !== step.value"
        [class.text-gray-600]="store.step() !== step.value"
        (click)="goToStep(step.value)"
      >
        {{ i + 1 }}. {{ step.label }}
      </button>
      }
    </div>

    @if (isPayeeStep()) {
    <lib-commission-invoice-payee-step
      [payeeType]="store.payeeType()"
      [selectedExpert]="store.selectedExpert()"
      [selectedOrg]="store.selectedOrg()"
      [locked]="lockedPayee()"
      (payeeTypeChange)="onPayeeTypeChange($event)"
      (expertSelected)="onExpertSelected($event)"
      (expertCleared)="onExpertCleared()"
      (orgSelected)="onOrgSelected($event)"
      (orgCleared)="onOrgCleared()"
    />
    } @else {
    <lib-commission-invoice-commissions-step
      [commissions]="store.pendingCommissions()"
      [payeeName]="store.payeeInfo()?.payeeName ?? ''"
      [selectedKeys]="store.selectedKeys()"
      [selectedTotal]="store.selectedTotal()"
      [(periodStart)]="periodStart"
      [(periodEnd)]="periodEnd"
      [(dueDate)]="dueDate"
      [(notes)]="notes"
      (toggleCommission)="toggleCommission($event)"
    />
    }

    <div
      class="flex border-t border-gray-200 pt-4"
      [class.justify-end]="isPayeeStep()"
      [class.justify-between]="isCommissionsStep()"
    >
      @if (isCommissionsStep()) {
      <shared-outlined-submit-button
        buttonText="Back"
        variant="secondary"
        (buttonClick)="onBack()"
      />
      }

      <div class="flex gap-3">
        @if (isPayeeStep()) {
        <shared-submit-button
          [buttonText]="'Next'"
          [loadingText]="'Loading...'"
          [disabled]="!canProceed() || store.loading()"
          [isLoading]="store.loading()"
          (buttonClick)="onNext()"
        />
        } @else {
        <shared-submit-button
          [buttonText]="'Create & Submit Invoice'"
          [loadingText]="'Creating...'"
          [disabled]="!hasSelections() || store.loading()"
          [isLoading]="store.loading()"
          (buttonClick)="onSubmit()"
        />
        }
      </div>
    </div>
  </div>
</div>
